'use strict';
module.exports = require('./Menubar.vue');